<h5 class="card-title">Organization Pulse Score</h5>
<ngx-charts-pie-chart
  [results]="pulseScore"
  [scheme]="colorScheme"
  [doughnut]="true"
  [legend]="false"
  [labels]="false">
</ngx-charts-pie-chart>




<p *ngIf="pulseScore && pulseScore.length > 0" class="text-center fw-bold fs-4 mb-0">{{ pulseScore[0].value }}%<span (click)="getHierarchy()" style="cursor: pointer;"> Hierarchy</span></p>
<p class="text-center text-muted">Teams’ Average Score</p>

